<div [ngClass]="cssService.sectionCardClass" class="flex flex-col gap-6">
  <div fxLayout="column" fxLayoutGap="5px">
    <!-- Sous total (Shipping cost && Delivery cost)-->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w"
      *ngIf="currSm.enable_shipping_cost> 0 || currSm.enable_delivery > 0 || credit_fid ||(merchantClient && merchantClient.id_group && discountClient>0)">
      <span class="mat-subheading-1">{{"basket.sub-total"|translate}}</span>
      <span class="mat-subheading-1">{{ totalPricePan | priceFilter}}</span>
    </div>
    <!--  %  fidelity discount en euros-->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w"
      *ngIf="merchantClient && merchantClient.id_group && discountClient>0">
      <span class="mat-subheading-1">{{"vipDiscount"|translate}} </span>
      <span class="mat-subheading-1"> - {{discountClient | priceFilter}}</span>
    </div>
    <!-- remise fidelity avantages-->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w" *ngIf="credit_fid && merchantClient">
      <span class="mat-subheading-1">{{ "endorder.cagnotte-fid" | translate | capitalize }}</span>
      <span class="mat-subheading-1">- {{fidelityDiscountUsed | priceFilter}}</span>
    </div>
    <!-- Shipping cost -->
    <div fxLayout="column" *ngIf="currSm.enable_shipping_cost > 0">
      <div fxLayout="row" fxLayoutAlign="space-between" class="full-w" *ngIf="isRelay">
        <span class="mat-subheading-1" *ngIf="isRelay">
          {{"basket.shipping-cost"|translate}} {{delivryAddress ? '(' + (delivryAddress.country_name | capitalize) + ')'
          : '' | capitalize}}:
        </span>
        <span class="mat-subheading-1" *ngIf="isRelay && selectedRelay">
          {{"basket.shipping-cost"|translate}} {{ '(' + selectedRelay.Pays + ')'}}:
        </span>
        <span class="mat-subheading-1 warn-ico" *ngIf="shippingPrice < 0">{{"basket.undefined"|translate}}</span>
        <span class="mat-subheading-1" *ngIf="shippingPrice > 0">
          {{shippingPrice | priceFilter}}
        </span>
        <span class="mat-subheading-1" *ngIf="shippingPrice === 0 && panier$.length === 0">
          {{0 | priceFilter}}
        </span>
        <span class="mat-subheading-1 great-ico boldest" *ngIf="shippingPrice === 0 && !shippingOffer && !needRelay">
          {{"basket.free"|translate}}
        </span>
        <span class="mat-subheading-1 great-ico boldest" *ngIf="shippingPrice === 0 && shippingOffer && !needRelay">
          {{"basket.offer"|translate}}
        </span>
        <span class="mat-caption warn-ico boldest text-center" *ngIf="needRelay">
          {{"basket.select-relay"|translate}}
        </span>
      </div>
      <!-- Shipping offer -->
      <div fxLayout="row" *ngIf="shippingOffer && shippingPrice> 0">
        <span class="mat-caption">
          ({{"basket.shipping-cost-offer"| translate}} {{shippingOffer | priceFilter}})
        </span>
      </div>
    </div>
    <!-- Delivery cost -->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w" *ngIf="currSm.enable_delivery > 0">
      <span class="mat-subheading-1">
        {{'BasketEnorderComponent.shippingCost'|translate}} {{delivryAddress ? '(' + (delivryAddress.city_name |
        capitalize) + ')' : ''}}:
      </span>
      <span class="mat-subheading-1 warn-ico" *ngIf="deliveryPrice === null">
        {{'BasketEnorderComponent.indefinite'|translate}}
      </span>
      <span class="mat-subheading-1" *ngIf="deliveryPrice > 0">
        {{deliveryPrice | priceFilter}}
      </span>
      <span class="mat-subheading-1" *ngIf="deliveryPrice === 0">
        {{'BasketEnorderComponent.free'|translate}}
      </span>
    </div>
    <!-- Errors shipping cost -->
    <div fxLayoutAlign="start center" class="warn-ico full-w layout-padd" *ngIf="shippingPrice <0">
      <span class="mat-subheading-1" *ngIf="shippingPrice === -1 && delivryAddress">
        {{"basket.weight-to-high"|translate}}
        <i class="material-icons clicked icon-info" angulartics2On="click" angularticsAction="openWeightTableDial"
          angularticsCategory="order" matTooltip="{{'basket.rate-weight-prices'|translate}}"
          (click)="myDials.openWeightTableDial(delivryAddress, isRelay, selectedRelay)">
          info
        </i>
      </span>
      <span class="mat-subheading-1" *ngIf="shippingPrice === -2 && delivryAddress">
        {{"basket.country-not-eligible" | translate}}
        <i class="material-icons clicked icon-info" angulartics2On="click" angularticsAction="openWeightTableDial"
          angularticsCategory="order" matTooltip="{{'basket.rate-weight-prices'|translate}}"
          (click)="myDials.openWeightTableDial(delivryAddress, isRelay, selectedRelay)">
          info
        </i>
      </span>
      <span class="mat-subheading-1" *ngIf="!delivryAddress">
        {{"basket.need-delivry-address" | translate}}
        <i class="material-icons clicked icon-info" angulartics2On="click" angularticsAction="openWeightTableDial"
          angularticsCategory="order" matTooltip="{{'basket.rate-weight-prices'|translate}}"
          (click)="myDials.openWeightTableDial(delivryAddress, isRelay, selectedRelay)">
          info
        </i>
      </span>
    </div>
    <!-- Errors delivry cost -->
    <div fxLayoutAlign="start center" class="warn-ico full-w layout-padd"
      *ngIf="currSm.enable_delivery > 0 && deliveryPrice === null">
      <span class="mat-subheading-1" *ngIf="delivryAddress">
        {{"basket.city-not-eligible" | translate}}
        <i class="material-icons clicked icon-info" angulartics2On="click" angularticsAction="openEligibleCitiesDial"
          angularticsCategory="order" matTooltip="{{'basket.eligible-cities-list' | translate}}"
          (click)="myDials.openEligibleCitiesDial()">
          info
        </i>
      </span>
      <span class="mat-subheading-1" *ngIf="!delivryAddress">
        {{"basket.need-delivry-address" | translate}}
        <i class="material-icons clicked icon-info" angulartics2On="click" angularticsAction="openEligibleCitiesDial"
          angularticsCategory="order" matTooltip="{{'basket.eligible-cities-list' | translate}}"
          (click)="myDials.openEligibleCitiesDial()">
          info
        </i>
      </span>
    </div>
    <!-- All total -->
    <div fxLayout="row" fxLayoutAlign="space-between" class="full-w">
      <span class="mat-title boldest" translate [translateParams]="{count:totalQuantPan}">
        basket.totalprod
      </span>
      <span class="mat-title boldest">{{(allTotal) | priceFilter}}</span>
    </div>
    <!-- Checkbox -->
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" [class.hidden]="activeDeviceandButtonTerms">
      <mat-checkbox class="great-ico" class="text-center" angulartics2On="click" angularticsAction="acceptTerms"
        angularticsCategory="order" [(ngModel)]="salesTerms" (change)="onChangesalesTerms()">
      </mat-checkbox>
      <div class="text-center">
        <span class="mat-caption">
          {{"basket.termAccord"|translate}}
          <strong class="primary-ico" (click)="goTerms()">
            {{"basket.termAccordSec"|translate}}
          </strong>
        </span>
      </div>
    </div>
    <div *ngIf="needSalesTerms " [class.hidden]="activeDeviceandButtonTerms">
      <span class="mat-subheading-1 warn-ico">{{"basket.termsAccept"|translate}}</span>
    </div>
  </div>
  <!-- Buttons (Paypal or not) -->
  <button class="w-full " (click)="presubmitOrder()" [ngClass]="cssService.defaultPrimaryButton"
    [disabled]="!activeButton" angulartics2On="click" angularticsAction="openConfirmOrderDialog"
    angularticsCategory="order" *ngIf="currPaymentChoice !== 'online_paypal' || !currPaymentChoice ">
    {{"basket.finalize-order" | translate}}
  </button>

  <!-- If paypal -->
  <div *ngIf="currPaymentChoice === 'online_paypal'" class="w-full flex flex-row justify-center">
    <div #paypal style="width: 750px;"></div>
  </div>
  <app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="statusMessage">
  </app-popup-loader>
</div>